import React from 'react'

import { Route, Switch } from 'react-router-dom'

import ScrollToTop from '../../Components/Scroll/ScrollToTop'
import LoadingSpinnerFull from '../../View/Widget/LoadingSpinner/Full'
import uris from './URI'

const Router: React.FC = () => {
  const routes = [
    {
      path: uris.home,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Home/Index')),
    },
    {
      path: `${uris.technology}/:slug`,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Services/Details')),
    },
    {
      path: uris.technology,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Services/Index')),
    },
    {
      path: uris.solutions,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Products/Management/Index')),
    },
    {
      path: uris.partners,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Partners/UserStories/Index')),
    },
    {
      path: uris.userStories,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Partners/UserStories/Index')),
    },
    {
      path: `${uris.userStories}/:id`,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Partners/UserStories/Details')),
    },
    {
      path: uris.ourPartners,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Partners/OurPartners/Index')),
    },
    {
      path: uris.trading,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Products/CopyTrading/Index')),
    },
    {
      path: uris.crypto,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Products/CryptoPortal/Index')),
    },
    {
      path: uris.historicalData,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Products/DataEcommerce/Index')),
    },
    {
      path: uris.strategies,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Products/TradingStrategies/Index')),
    },
    {
      path: uris.socialNewsApi,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Products/TraderNewsApi/Index')),
    },
    {
      path: uris.contact,
      exact: true,
      Component: React.lazy(() => import('../../Controller/Contact/Index')),
    },
    {
      path: uris.about,
      exact: true,
      Component: React.lazy(() => import('../../Controller/About/Index')),
    },
    {
      path: uris.privacyPolicy,
      exact: true,
      Component: React.lazy(() => import('../../Controller/PrivacyPolicy/Index')),
    },
    {
      path: uris.termsOfUse,
      exact: true,
      Component: React.lazy(() => import('../../Controller/TermsOfUse/Index')),
    },
    {
      path: '*',
      Component: React.lazy(() => import('../../Controller/Error/404/Index')),
    },
  ]

  return (
    <ScrollToTop>
      <Route
        render={(state) => {
          const { location } = state
          return (
            <Switch location={location}>
              {routes.map(({ path, Component, exact }) => (
                <Route
                  path={path}
                  key={path}
                  exact={exact}
                  render={() => (
                    <React.Suspense fallback={<LoadingSpinnerFull loading />}>
                      <Component />
                    </React.Suspense>
                  )}
                />
              ))}
            </Switch>
          )
        }}
      />
    </ScrollToTop>
  )
}

export default Router
